import { Link } from 'react-router-dom';

export default function ReviewsQuickLinks() {
  const links = [
    {
      title: 'Write a Review',
      description: 'Share your experience with us',
      icon: 'ri-edit-line',
      path: '/write-a-review',
      color: 'bg-[#E8B84B]',
    },
    {
      title: 'Browse Inventory',
      description: 'Find your perfect vehicle today',
      icon: 'ri-car-line',
      path: '/inventory',
      color: 'bg-[#1C2B1E]',
    },
    {
      title: 'Contact Us',
      description: 'Get in touch with our team',
      icon: 'ri-phone-line',
      path: '/contact',
      color: 'bg-[#E8B84B]',
    },
  ];

  return (
    <nav aria-label="Explore more sections" className="bg-white py-12 border-t border-[#E8E2D6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="font-['Oswald'] text-3xl sm:text-4xl font-bold text-[#1C2B1E] mb-2">
            Explore More
          </h2>
          <p className="text-[#374151]">
            Continue your journey with Rockhound Auto Sales
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {links.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className="bg-[#F7F5F0] rounded-2xl border border-[#E8E2D6] p-8 text-center hover:border-[#E8B84B] hover:shadow-lg transition-all group"
              aria-label={`${link.title} — ${link.description}`}
            >
              <div aria-hidden="true" className={`inline-flex items-center justify-center w-16 h-16 ${link.color} rounded-full mb-4`}>
                <i className={`${link.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="font-['Oswald'] text-2xl font-bold text-[#1C2B1E] mb-2 group-hover:text-[#92650a] transition-colors">
                {link.title}
              </h3>
              <p className="text-[#374151] mb-4 text-sm">
                {link.description}
              </p>
              <div className="inline-flex items-center gap-2 text-[#92650a] font-medium" aria-hidden="true">
                Learn More
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
